import { render, staticRenderFns } from "./ArResourcesForms.vue?vue&type=template&id=74629b70&"
import script from "./ArResourcesForms.vue?vue&type=script&lang=js&"
export * from "./ArResourcesForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports